import React from 'react';
import PropTypes from 'prop-types';
import { TriangleAlert } from 'lucide-react';
import { DEPLOYMENT_ENV, IS_PRODUCTION_BUILD } from '../../config/environment';

// Marks every non-production checkout (beta, uat, development, docker), so nobody
// mistakes a testing deployment for the live one - the same marker the CRM and the
// Ordergate admin carry. Renders nothing on production.
//
// `floating` pins it to the window's top-right corner, for the pages outside the
// layout's header. `className` places it in the header.
function EnvironmentBadge({ floating, className }) {
  if (IS_PRODUCTION_BUILD) return null;

  const deployment = DEPLOYMENT_ENV ? ` (${DEPLOYMENT_ENV})` : '';

  return (
    <span
      title={`This is a testing version of Ordergate${deployment}, not the live one.`}
      className={`inline-flex shrink-0 items-center gap-1 h-[26px] px-2 rounded-md border border-[#ad4e00] bg-[#fff7e6] text-[#ad4e00] text-xs font-bold tracking-wide whitespace-nowrap cursor-default ${floating ? 'fixed top-3 right-3 z-50 shadow-md' : ''} ${className}`}
    >
      <TriangleAlert className="w-3.5 h-3.5" aria-hidden="true" />
      Testing Only
    </span>
  );
}

EnvironmentBadge.propTypes = {
  floating: PropTypes.bool,
  className: PropTypes.string,
};
EnvironmentBadge.defaultProps = {
  floating: false,
  className: '',
};

export default EnvironmentBadge;
